/* eslint-disable no-unused-vars */
/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/alt-text */
import "./App.css";
import "./styleguide.css";

import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

//images import
import InvestigateOurSolarSystem from "./components/InvestigateOurSolarSystem";
import Web1920115 from "./components/Web1920115";
import Web192010 from "./components/Web192010";
import Web192011 from "./components/Web192011";
import Web192022 from "./components/Web192022";
import Web192021 from "./components/Web192021";
import Web192031 from "./components/Web192031";
import Web192026 from "./components/Web192026";
import Web192030 from "./components/Web192030";
import Web192080 from "./components/Web192080";
import Web192079 from "./components/Web192079";
import Web1920128 from "./components/Web1920128";
import Web1920154 from "./components/Web1920154";
import IWantToSeeADifferentGalaxy from "./components/IWantToSeeADifferentGalaxy";
import Web192029 from "./components/Web192029";
import Web192027 from "./components/Web192027";
import Web192032 from "./components/Web192032";
import Web192024 from "./components/Web192024";
import Web192052 from "./components/Web192052";
import Web192053 from "./components/Web192053";
import Web192054 from "./components/Web192054";
import Web192081 from "./components/Web192081";
import Web1920101 from "./components/Web1920101";
import Web1920187 from "./components/Web1920187";
import SingleImage from "./components/SingleImage";
import Web1920102 from "./components/Web1920102";
import Web1920130 from "./components/Web1920130";
import Web1920129 from "./components/Web1920129";
import Web1920131 from "./components/Web1920131";
import Web1920116 from "./components/Web1920116";
import Web1920150 from "./components/Web1920150";
import Web1920153 from "./components/Web1920153";
import Web192055 from "./components/Web192055";
import Web192035 from "./components/Web192035";
import Web192036 from "./components/Web192036";
import Web192037 from "./components/Web192037";
import AncientStars1 from "./components/AncientStars1";
import Web192038 from "./components/Web192038";
import Web1920104 from "./components/Web1920104";
import Web1920103 from "./components/Web1920103";
import Web1920105 from "./components/Web1920105";
import ExploreOurMilkyWay from "./components/ExploreOurMilkyWay";
import Web192018 from "./components/Web192018";
import Web192020 from "./components/Web192020";
import Web1920135 from "./components/Web1920135";
import Web1920138 from "./components/Web1920138";
import Web1920146 from "./components/Web1920146";
import Web192059 from "./components/Web192059";
import Web19201152 from "./components/Web19201152";
import Web1920136 from "./components/Web1920136";
import Web1920139 from "./components/Web1920139";
import Web1920145 from "./components/Web1920145";
import Web1920147 from "./components/Web1920147";
import Web192060 from "./components/Web192060";
import Web192061 from "./components/Web192061";
import Web192062 from "./components/Web192062";
import Web1920186 from "./components/Web1920186";
import Web1920155 from "./components/Web1920155";
import Web192023 from "./components/Web192023";
import Web1920137 from "./components/Web1920137";
import Web1920142 from "./components/Web1920142";
import Web1920148 from "./components/Web1920148";
import Web1920189 from "./components/Web1920189";
import Web1920152 from "./components/Web1920152";
import Web1920152New from "./components/Web1920152New";
import Web1920179 from "./components/Web1920179";
import Web1920188 from "./components/Web1920188";
import Web1920180 from "./components/Web1920180";
import Web1920158 from "./components/Web1920158";
import ImageHolder from "./components/ImageHolder";
//images import
import overlapGroup1_192011 from "./static/img/49757380101-c6ec88d22d-6k-1@1x.png";
import finalOverlay from "./static/img/final-overlay-10@1x.png";
import hubble from "./static/img/hubble-1@1x.png";
import nasa_logo from "./static/img/NASA_Insignia.jpg";
import subtraction1 from "./static/img/outer-d.png";
import subtraction1_10 from "./static/img/outer-d.png";
import warp_10 from "./static/img/warp-10@1x.png";
import path_14_10 from "./static/img/path-14-10@1x.png";
import path_14_5 from "./static/img/path-14-5@1x.png";
import path_15 from "./static/img/path-15-1@1x.png";
import path_15_2 from "./static/img/path-15-2@1x.png";
import group_583 from "./static/img/group-281-10@1x.png";
import web1920128_stsci from "./static/img/stsci-01evskx04d9j11vy2q6y81yfd8@1x.png";
import overlay_whirpool_flythrough from "./static/img/whirpool-flythrough@1x.png";
import x45943962354_929Ead0C96_K from "./static/img/45943962354-929ead0c96-k-1@1x.jpg";
import x45750896405_3918F5Bbab_K from "./static/img/45750896405-3918f5bbab-k-1@1x.jpg";
import group138_main from "./static/img/group-138@1x.png";
import path128_10 from "./static/img/path-128-10@1x.png";
import group138_10 from "./static/img/group-138-10@1x.png";
import x40387946030_Aa1Ab05241_3K from "./static/img/40387946030-aa1ab05241-3k-1@1x.png";
import x40370191930_E4B5C31906_6K from "./static/img/40370191930-e4b5c31906-6k-1@1x.png";
import x47508827662_0Fb5Ab33C6_4K from "./static/img/47508827662-0fb5ab33c6-4k-1@1x.jpg";
import path128_13 from "./static/img/path-128-13@1x.png";
import overlapGroup1_k_1 from "./static/img/46313556131-736414a7b5-k-1@1x.png";
import overlapGroup1_saturn_aurora_video from "./static/img/saturn-aurora-video@1x.png";
import overlapGroup1_goodsfields from "./static/img/goodsfield@1x.png";
import overlapGroup1_antennae_galexy from "./static/img/antennae-galaxy@1x.png";
import overlapGroup1_untitled_1 from "./static/img/untitled@1x.png";
import overlapGroup1_51218566742_5029299867_k_1 from "./static/img/51218566742-5029299867-k-1@1x.png";
import x50173806488_38F6267B2A_5K from "./static/img/50173806488-38f6267b2a-5k-1@1x.png";
import path15_10 from "./static/img/path-15-10@1x.png";
import overlapGroup1_butterfly_mp4 from "./static/img/13998-butterfly-mp4@1x.png";
import overlapGroup1_butterfly_flythrough_compresseed from "./static/img/butterfly-flythrough-compresseed@1x.png";
import overlapGroup_38451843462_e970e5f167_k_1 from "./static/img/38451843462-e970e5f167-k-1@1x.png";
import x36345580381_68E41A943C_K_36345580381_68e41a943c_k_1 from "./static/img/36345580381-68e41a943c-k-1@1x.png";
import overlapGroup_27950248711_d1329dfb69_6k_1 from "./static/img/27950248711-d1329dfb69-6k-1@1x.png";
import overlapGroup1_24850475098_dc9abdf3b9_4k_1 from "./static/img/24850475098-dc9abdf3b9-4k-1@1x.png";
import overlapGroup1_sunburst_artist from "./static/img/sunburst-artist@1x.png";
import x48531638526_5A2091777A_3K_48531638526_5a2091777a_3k from "./static/img/48531638526-5a2091777a-3k@1x.jpg";
import finalOverlay_final_overlay_10 from "./static/img/final-overlay-10@1x.png";
import group64_group_63 from "./static/img/group-63@1x.png";
import group66_group_65 from "./static/img/group-65@1x.png";
import group85_group_84_1 from "./static/img/group-84-1@1x.png";
import overlapGroup3_49757380101_c6ec88d22d_6k_1 from "./static/img/49757380101-c6ec88d22d-6k-1@1x.jpg";
import rectangle19_rectangle_19_1 from "./static/img/rectangle-19-1@1x.png";
import path14_path_14_1 from "./static/img/path-14-1@1x.png";
import group42_group_41 from "./static/img/group-41@1x.png";
import path661_path_661 from "./static/img/path-661@1x.png";
import group287_group_100 from "./static/img/group-100@1x.png";
import group45_group_45 from "./static/img/group-45@1x.png";
import path691_path_691_10 from "./static/img/path-691-10@1x.png";
import overlapGroup5_path_407_10 from "./static/img/path-407-10@1x.png";
import polygon3_polygon_3_10 from "./static/img/polygon-3-10@1x.png";
import path691_path_691_2 from "./static/img/path-691-2@1x.png";
import path692_path_692_11 from "./static/img/path-692-11@1x.png";
import path400_path_400 from "./static/img/path-400@1x.png";
import path318_path_318_1 from "./static/img/path-318-1@1x.png";
import differentgalaxy_Bg_differentgalaxy_bg from "./static/img/differentgalaxy-bg@1x.png";
import group95_group_94 from "./static/img/group-94@1x.png";
import group97_group_9_1 from "./static/img/group-96-1@1x.png";
import group99_group_98 from "./static/img/group-98@1x.png";
import path691_path_691_11 from "./static/img/path-691-11@1x.png";
import x698_698_1 from "./static/img/698-1@1x.jpg";
import group167_group_49 from "./static/img/group-49@1x.png";
import group166_group_75 from "./static/img/group-75@1x.png";
import path692_path_692_10 from "./static/img/path-692-11@1x.png";
import line39_1 from "./static/img/line-39@1x.png";
import line41_1 from "./static/img/line-41@1x.png";
import line43_1 from "./static/img/line-43@1x.png";
import group78_group_77 from "./static/img/group-77@1x.png";
import line46_line_45 from "./static/img/line-45@1x.png";
import line47_1 from "./static/img/line-47@1x.png";
import line49_1 from "./static/img/line-49@1x.png";
import group80_circle from "./static/img/circle.png";
import group165_group_102 from "./static/img/group-102@1x.png";
import path128_path_128_9 from "./static/img/path-128-9@1x.png";
import path692_path_692_9 from "./static/img/path-692-9@1x.png";
import group136_1 from "./static/img/group-133-1@1x.png";
import group270_group_270_1 from "./static/img/group-270-1@1x.png";
import group267_group_266_1 from "./static/img/group-266-1@1x.png";
import group145_group_144 from "./static/img/group-144@1x.png";
import path14_path_14_9 from "./static/img/path-14-9@1x.png";
import rocket_img from "./static/img/rocket.png";
import music_img from "./static/img/music.png";
import timer_img from "./static/img/timer.png";
import star_img from "./static/img/star.png";
import saturn_img from "./static/img/saturn.png";
import globe_img from "./static/img/globe.png";
import right_wing from "./static/img/path-691-2@1x.png";
import left_wing from "./static/img/path-692-11@1x.png";
import click_me from "./static/img/click_me.png";

//videos
import warp_video from "./static/videos/warp-loader.mp4";
import marsMoon_video from "./static/videos/Mars-moon.mp4";
import butterfly_video from "./static/videos/butterfly-flythrough-compresseed .mp4";
import westurlund_video from "./static/videos/STScI-01EVSKCAH1X78111AQBDZGAAXP.mp4";
import pillar_video from "./static/videos/PillarsSonification.mp4";
import saturn_video from "./static/videos/saturn-aurora-video.mp4";
import butterfly_sound_video from "./static/videos/Butterfly.mp4";
import cats_eye_video from "./static/videos/CatsEye.mp4";
import arp_video from "./static/videos/Rendezvous with Interacting Galaxies Arp 273.mp4";
import Astroid_2010a from "./static/videos/Astroid-2010a.mp4";
import jupiter_video_new from "./static/videos/jupiter-video.mp4";
import abell370_video from "./static/videos/Abell-370.mp4";
import rxc_video from "./static/videos/RXC.mp4";
import ngc_1300_video from "./static/videos/ngc_1300.mp4 (1080p).mp4";
import ultra_deepfield_zoom from "./static/videos/xdf.mp4";
import Ultra_Deep_Field from "./static/videos/HUDF.mp4";
import crab_nebula_video from "./static/videos/crab_for_ed.mp4 (1080p).mp4";
import veil_nebula_video from "./static/videos/veil_new.mp4";
import cosmic_vido from "./static/videos/STScI-01EVS1S11EEB20H6G3YJNAXV1W.mp4";
import orion_nebula_video from "./static/videos/orion_new.mp4 (1080p).mp4";
import jupiter_video from "./static/videos/aurora.mp4";
import caldwell_video from "./static/videos/caldwell_73.mp4 (1440p).mp4";
import bubble_video from "./static/videos/bubble.mp4";
import ulra_deep_video from "./static/videos/HUDF.mp4";
import ngc_video from "./static/videos/ngc_2392_no_mea.mp4";
import westurlund_sonification_video from "./static/videos/Wusterland 2Sonification.mp4";
import { addDeviceTypeInHtml } from "./helpers";
import { getBrowserName } from "./helpers/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { enterFullScreen } from "./helpers/";
// import Web192062 from "./components/Web192062";
function App() {
  useEffect(() => {
    let currentToast = null;
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && currentToast) {
        toast.dismiss(currentToast);
        currentToast = null;
      } else if (document.visibilityState === 'visible' && !currentToast) {
        currentToast = toast.success(<CustomToastWithLink />);
      }
    };

    if (window.innerHeight > window.innerWidth) {
      alert("You are in portrait mode. Please use landscape mode for better visuals.");
    }
    addDeviceTypeInHtml(getBrowserName());
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      if (currentToast) {
        toast.dismiss(currentToast);
        currentToast = null;
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const CustomToastWithLink = () => (
    <>
      <div className="box-session">
        <div className="inner-content">
          <p className="lato-bold-white-32px">Please press continue button to proceed.</p>
          <div className="button-container">
            <button type="button" onClick={() => { toast.dismiss(); enterFullScreen(document.body); }}>Continue</button>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Routes>
        <Route exact path="/imageOnly" element={<ImageHolder />} />
        <Route exact path="/" element={<Web192011 {...web192011Data} />} />

        <Route
          path="/web-1920-10"
          element={<Web192010 {...web192010Data} />}
        />

        <Route
          path="/investigate-our-solar-system"
          element={
            <InvestigateOurSolarSystem {...investigateOurSolarSystemData} />
          }
        />

        <Route
          path="/web-1920-115"
          element={
            <Web1920115 video={marsMoon_video} backToImage="BACK TO IMAGE" />
          }
        />

        <Route
          path="/web-1920-117/:videoIndex"
          element={
            <Web19201152
              westurlund_video={westurlund_video}
              cosmic_video={cosmic_vido}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-22/:reload"
          element={<Web192022 {...web192022Data} />}
        />

        <Route
          path="/web-1920-21"
          element={
            <Web192021
              warp={warp_video}
              finalOverlay={finalOverlay}
              path14={path_14_10}
              path15={path_15_2}
              subtraction1={subtraction1}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-31/:reload"
          element={<Web192031 {...web192031Data} />}
        />

        <Route
          path="/web-1920-26"
          element={
            <Web192026
              warp={warp_video}
              finalOverlay={finalOverlay}
              path14={path_14_10}
              path15={path_15}
              subtraction1={subtraction1}
              group583={group_583}
            />
          }
        />
        <Route
          path="/web-1920-30"
          element={
            <Web192030
              warp={warp_video}
              finalOverlay={finalOverlay}
              path14={path_14_5}
              path15={path_15}
              subtraction1={subtraction1_10}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-80/:reload"
          element={<Web192080 {...web192080Data} />}
        />

        <Route
          path="/web-1920-79"
          element={
            <Web192079
              warp={warp_video}
              finalOverlay={finalOverlay}
              subtraction1={subtraction1_10}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-128"
          element={
            <Web1920128
              video={Astroid_2010a}
              overlapGroup1={web1920128_stsci}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-154"
          element={
            <Web1920154
              overlapGroup1={overlay_whirpool_flythrough}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/i-want-to-see-a-different-galaxy"
          element={
            <IWantToSeeADifferentGalaxy {...iWantToSeeADifferentGalaxyData} />
          }
        />

        <Route
          path="/web-1920-29"
          element={
            <Web192029
              x45943962354_929Ead0C96_K={x45943962354_929Ead0C96_K}
              group138={group138_main}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/web-1920-27/:reload"
          element={<Web192027 {...web192027Data} />}
        />

        <Route
          path="/web-1920-32"
          element={
            <Web192032
              x45750896405_3918F5Bbab_K={x45750896405_3918F5Bbab_K}
              group138={group138_10}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/web-1920-24"
          element={
            <Web192024
              group138={group138_10}
              path128={path128_10}
              group112Props={web192024Data.group112Props}
            />
          } 
        />

        <Route
          path="/web-1920-52"
          element={
            <Web192052
              warp={warp_video}
              finalOverlay={finalOverlay}
              subtraction1={subtraction1_10}
              group281={group_583}
            />
          }
        />

        <Route
          path="/web-1920-53/:reload"
          element={<Web192053 {...web192053Data} />}
        />

        <Route
          path="/web-1920-54"
          element={
            <Web192054
              x40387946030_Aa1Ab05241_3K={x40387946030_Aa1Ab05241_3K}
              title="Option 2"
              group138={group138_10}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/web-1920-81"
          element={
            <Web192081
              x40370191930_E4B5C31906_6K={x40370191930_E4B5C31906_6K}
              option2="Option 2"
              group138={group138_10}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/web-1920-101/:reload"
          element={<Web1920101 {...web1920101Data} />}
        />

        <Route
          path="/web-1920-102"
          element={
            <Web1920102
              x47508827662_0Fb5Ab33C6_4K={x47508827662_0Fb5Ab33C6_4K}
              option2="Option 2"
              group138={group138_10}
              path128={path128_13}
            />
          }
        />

        <Route
          path="/web-1920-130"
          element={<Web1920130 {...web1920130Data} />}
        />

        <Route
          path="/web-1920-129"
          element={
            <Web1920129
              warp={warp_10}
              finalOverlay={finalOverlay}
              subtraction1={subtraction1}
              group281={group_583}
            />
          }
        />

        <Route
          path="/web-1920-131"
          element={
            <Web1920131
              overlapGroup1={overlapGroup1_k_1}
              group138={group138_10}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/web-1920-116/:videoIndex"
          element={
            <Web1920116
              jupiter_video={jupiter_video}
              saturn_video={saturn_video}
              jupiter_video_new={jupiter_video_new}
              overlapGroup1={overlapGroup1_saturn_aurora_video}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-150"
          element={
            <Web1920150
              overlapGroup1={overlapGroup1_goodsfields}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-153"
          element={
            <Web1920153
              overlapGroup1={overlapGroup1_antennae_galexy}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-55"
          element={
            <Web192055
              warp={warp_video}
              finalOverlay={finalOverlay}
              subtraction1={subtraction1}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-35"
          element={
            <Web192035
              warp={warp_video}
              finalOverlay={finalOverlay}
              subtraction1={subtraction1_10}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-36/:reload"
          element={<Web192036 {...web192036Data} />}
        />

        <Route
          path="/web-1920-37"
          element={
            <Web192037
              video={ultra_deepfield_zoom}
              overlapGroup1={overlapGroup1_untitled_1}
              visualization="VISUALIZATION"
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/multiple-galaxies"
          element={<AncientStars1 {...ancientStars1Data} />}
        />

        <Route
          path="/web-1920-38/:videoIndex"
          element={
            <Web192038
              {...web192038Data}
              ulra_deep_video={ulra_deep_video}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-104/:reload"
          element={<Web1920104 {...web1920104Data} />}
        />

        <Route
          path="/web-1920-103"
          element={
            <Web1920103
              warp={warp_video}
              finalOverlay={finalOverlay}
              subtraction1={subtraction1_10}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-105"
          element={
            <Web1920105
              x50173806488_38F6267B2A_5K={x50173806488_38F6267B2A_5K}
              group138={group138_10}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/explore-our-milky-way"
          element={<ExploreOurMilkyWay {...exploreOurMilkyWayData} />}
        />

        <Route
          path="/web-1920-18"
          element={
            <Web192018
              warp={warp_video}
              finalOverlay={finalOverlay}
              path14={path_14_5}
              path15={path15_10}
              subtraction1={subtraction1_10}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-20/:reload"
          element={<Web192020 {...web192020Data} />}
        />

        <Route
          path="/web-1920-135"
          element={
            <Web1920135
              warp={warp_10}
              finalOverlay={finalOverlay}
              path14={path14_path_14_9}
              path15={path_15}
              subtraction1={subtraction1}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-138"
          element={
            <Web1920138
              warp={warp_video}
              finalOverlay={finalOverlay}
              path14={path_14_10}
              path15={path_15}
              subtraction1={subtraction1_10}
              group583={group_583}
            />
          }
        />

        <Route
          path="/web-1920-146"
          element={
            <Web1920146
              warp={warp_10}
              finalOverlay={finalOverlay}
              path14={path_14_10}
              path15={path15_10}
              subtraction1={subtraction1_10}
              group583={group_583}
              video={warp_video}
            />
          }
        />

        <Route
          path="/web-1920-59/:reload"
          element={
            <Web192059
              {...web192059Data}
              video={butterfly_sound_video}
              overlapGroup1={overlapGroup1_butterfly_mp4}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-158"
          element={
            <Web1920158
              {...web1920158Data}
              video={cats_eye_video}
              overlapGroup1={overlapGroup1_butterfly_mp4}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-136"
          element={<Web1920136 {...web1920136Data} />}
        />

        <Route
          path="/web-1920-139"
          element={
            <Web1920139
              overlapGroup1="/{overlapGroup1_orion_vis_1920}"
              visualization="VISUALIZATION"
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-145/:videoIndex"
          element={
            <Web1920145
              {...web1920145Data}
              pillar_video={pillar_video}
              orion_nebula_video={orion_nebula_video}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-147/:reload"
          element={<Web1920147 {...web1920147Data} ngc_video={ngc_video} />}
        />

        <Route
          path="/web-1920-60"
          element={
            <Web192060
              video={butterfly_video}
              overlapGroup1={overlapGroup1_butterfly_flythrough_compresseed}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-61"
          element={
            <Web192061
              video={crab_nebula_video}
              overlapGroup1={overlapGroup1_butterfly_flythrough_compresseed}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-62"
          element={
            <Web192062
              video={veil_nebula_video}
              overlapGroup1={overlapGroup1_butterfly_flythrough_compresseed}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-186"
          element={
            <Web1920186
              video={bubble_video}
              overlapGroup1={overlapGroup1_butterfly_flythrough_compresseed}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/web-1920-187"
          element={
            <Web1920187
              video={arp_video}
              overlapGroup1={overlapGroup1_butterfly_flythrough_compresseed}
              backToImage="BACK TO IMAGE"
            />
          }
        />

        <Route
          path="/single-image"
          element={<SingleImage backToImage="BACK TO IMAGE" />}
        />

        <Route
          path="/web-1920-155/:reload"
          element={<Web1920155 {...web1920155Data} />}
        />

        <Route
          path="/web-1920-23"
          element={
            <Web192023
              x36345580381_68E41A943C_K={
                x36345580381_68E41A943C_K_36345580381_68e41a943c_k_1
              }
              group138={group138_10}
              path128={path128_10}
            />
          }
        />

        <Route
          path="/web-1920-137"
          element={
            <Web1920137
              overlapGroup={overlapGroup_38451843462_e970e5f167_k_1}
            />
          }
        />

        <Route
          path="/web-1920-142"
          element={
            <Web1920142
              overlapGroup={overlapGroup_27950248711_d1329dfb69_6k_1}
              group181Props={web1920142Data.group181Props}
            />
          }
        />

        <Route
          path="/web-1920-148"
          element={
            <Web1920148
              overlapGroup1={overlapGroup1_24850475098_dc9abdf3b9_4k_1}
              path14={path_14_10}
              path15={path15_10}
              group138={group138_10}
              path128={path128_13}
            />
          }
        />
        <Route
          path="/web-1920-152"
          element={
            <Web1920152
              overlapGroup1={overlapGroup1_sunburst_artist}
              video={abell370_video}
              backToImage="BACK TO IMAGE"
              artistsImpression="ARTIST'S IMPRESSION"
              overlapGroup2={overlapGroup5_path_407_10}
              polygon3={polygon3_polygon_3_10}
              click_me={click_me}
            />
          }
        />
        <Route
          path="/web-1920-152-2"
          element={
            <Web1920152New
              overlapGroup1={overlapGroup1_sunburst_artist}
              video={rxc_video}
              backToImage="BACK TO IMAGE"
              artistsImpression="ARTIST'S IMPRESSION"
              overlapGroup2={overlapGroup5_path_407_10}
              polygon3={polygon3_polygon_3_10}
              click_me={click_me}
            />
          }
        />
        <Route
          path="/web-1920-179"
          element={
            <Web1920179
              overlapGroup1={overlapGroup1_sunburst_artist}
              video={ngc_video}
              backToImage="BACK TO IMAGE"
              artistsImpression="ARTIST'S IMPRESSION"
              overlapGroup2={overlapGroup5_path_407_10}
              polygon3={polygon3_polygon_3_10}
              click_me={click_me}
            />
          }
        />
        <Route
          path="/web-1920-188"
          element={
            <Web1920188
              overlapGroup1={overlapGroup1_sunburst_artist}
              video={caldwell_video}
              backToImage="BACK TO IMAGE"
              artistsImpression="ARTIST'S IMPRESSION"
              overlapGroup2={overlapGroup5_path_407_10}
              polygon3={polygon3_polygon_3_10}
              click_me={click_me}
            />
          }
        />
        <Route
          path="/web-1920-189"
          element={
            <Web1920189
              overlapGroup1={overlapGroup1_sunburst_artist}
              video={ngc_1300_video}
              backToImage="BACK TO IMAGE"
              artistsImpression="ARTIST'S IMPRESSION"
              overlapGroup2={overlapGroup5_path_407_10}
              polygon3={polygon3_polygon_3_10}
              click_me={click_me} //image na aye to route par is tara sai click me call kare thankyou
            />
          }
        />
        <Route
          path="/web-1920-180"
          element={
            <Web1920180
              overlapGroup1={overlapGroup1_sunburst_artist}
              video={westurlund_sonification_video}
              backToImage="BACK TO IMAGE"
              artistsImpression="ARTIST'S IMPRESSION"
              overlapGroup2={overlapGroup5_path_407_10}
              polygon3={polygon3_polygon_3_10}
              click_me={click_me}
            />
          }
        />
      </Routes>
      <ToastContainer
        limit={1}
        position="bottom-center"
        autoClose={false}
        closeButton={false}
        hideProgressBar={false}
        closeOnClick={false}
        icon={""}
        className={"cyoa_toast_container"}
      />
    </>
  );
}
export default App;

const web192011Data = {
  overlapGroup1: overlapGroup1_192011,
  hubble: hubble,
  nasa_logo: nasa_logo,
  subtraction1: subtraction1,
  chooseYourJourneyInTheUniverse: "CHOOSE YOUR JOURNEY IN THE UNIVERSE",
  play: "PLAY",
  hubblesCosmicAdventure: "HUBBLE'S COSMIC ADVENTURE",
};

const investigateOurSolarSystemData = {
  x48531638526_5A2091777A_3K:
    x48531638526_5A2091777A_3K_48531638526_5a2091777a_3k,
  finalOverlay: finalOverlay_final_overlay_10,
  spanText1: (
    <React.Fragment>
      The inner solar system includes the rocky planets – Mercury, Venus, Earth,
      and Mars – and the asteroid belt. The outer solar system is made up of
      Jupiter, Saturn, Uranus, Neptune, and the objects beyond, including the Kuiper Belt
      and the farther-away Oort Cloud. <br />
    </React.Fragment>
  ),
  spanText2: "What would you like to visit?",
  letsLookAtOurSolarSystem: "LET'S LOOK AT OUR SOLAR  SYSTEM",
  path14: path_14_5,
  path15: path_15,
  subtraction1: subtraction1,
  theOuterSolarSystem: (
    <React.Fragment>
      THE OUTER <br />
      SOLAR SYSTEM
    </React.Fragment>
  ),
  group64: group64_group_63,
  theInnerSolarSystem: "THE  INNER SOLAR  SYSTEM",
  group66: group66_group_65,
  artistRendition: "ARTIST RENDITION",
  cometsAndAstroids: "COMETS AND ASTEROIDS",
  group85: group85_group_84_1,
  group583: group_583,
};

const group1362Data = {
  className: "group-136-1",
};

const web192010Data = {
  overlapGroup3: overlapGroup3_49757380101_c6ec88d22d_6k_1,
  finalOverlay: finalOverlay_final_overlay_10,
  hubble: hubble,
  nasa_logo: nasa_logo,
  rectangle19: rectangle19_rectangle_19_1,
  spanText1: (
    <React.Fragment>
      Welcome aboard the USS Hubble, named after Earth's Hubble Space Telescope
      and famous astronomer Edwin Hubble! Your mission is to observe objects
      throughout our universe.
      <br />
    </React.Fragment>
  ),
  spanText2: "What would you like to do?",
  path14: path14_path_14_1,
  greetingsExplorer: "GREETINGS, EXPLORER.",
  subtraction1: subtraction1,
  group42: group42_group_41,
  investigateOurSolarSystem: (
    <React.Fragment>
    INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  path661: path661_path_661,
  exploreTheMilkyWayGalaxy: "EXPLORE OUR GALAXY",
  group287: group287_group_100,
  group45: group45_group_45,
  checkOutADifferentGalaxy: "VISIT OTHER GALAXIES",
  group136Props: group1362Data,
};

const group5801Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
};

const web192022Data = {
  finalOverlay: finalOverlay_final_overlay_10,
  subtraction1: subtraction1_10,
  group583: group_583,
  watchOrbit: (
    <React.Fragment>
      WATCH THE <br />
      ORBIT
    </React.Fragment>
  ),
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  saturn: saturn_img,
  learnMore: "VISIT OTHER GALAXIES",
  travelToMilkyWay: (
    <React.Fragment>
      EXPLORE OUR <br />
      GALAXY
    </React.Fragment>
  ),
  overlapGroup5: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
    INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  click_me: click_me,
  travelAgainInSolarSystem: (
    <React.Fragment>
      TRAVEL AGAIN <br />
      IN THE SOLAR SYSTEM
    </React.Fragment>
  ),
  group580Props: group5801Data,
};
const group5802Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-1",
  click_me: click_me,
};

const web192031Data = {
  x45750896405_3918F5Bbab_K: x45750896405_3918F5Bbab_K,
  subtraction1: subtraction1_10,
  finalOverlay: finalOverlay,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  timelapse: (
    <React.Fragment>
      WATCH <br />
      TIMELAPSE
    </React.Fragment>
  ),
  wingright: right_wing,
  timer: timer_img,
  leftwing: left_wing,
  learnMore: "VISIT OTHER GALAXIES",
  overlapGroup4: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
     INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  travelAgainInSolarSystem: (
    <React.Fragment>
      TRAVEL AGAIN <br />
      IN SOLAR SYSTEM
    </React.Fragment>
  ),
  travelToMilkyWay: (
    <React.Fragment>
      EXPLORE OUR <br />
      GALAXY
    </React.Fragment>
  ),
  group580Props: group5802Data,
};

const group5803Data = {
  path691: path691_path_691_2,
  path692: path692_path_692_11,
  className: "group-580-2",
  click_me: click_me,
};

const web192080Data = {
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  path400: path400_path_400,
  path318: path318_path_318_1,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  music: music_img,
  rocket: rocket_img,
  wingright: right_wing,
  leftwing: left_wing,
  flyToIt: "FLY ME TO IT",
  turnToSound: "TRANSLATE INTO SOUND",
  learnMore: "VISIT ANOTHER GALAXY",
  flyBackToSolarSystem: (
    <React.Fragment>
         INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  overlapGroup5: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  travelAgainInGalaxies: (
    <React.Fragment>
      EXPLORE OUR <br /> GALAXY
    </React.Fragment>
  ),
  group580Props: group5803Data,
};

const group1364Data = {
  className: "group-136-3",
};

const iWantToSeeADifferentGalaxyData = {
  differentgalaxy_Bg: differentgalaxy_Bg_differentgalaxy_bg,
  finalOverlay: finalOverlay,
  path14: path_14_5,
  path15: path15_10,
  subtraction1: subtraction1_10,
  interactingGalaxy: "INTERACTING GALAXY",
  group95: group95_group_94,
  showMeALotOfThem: (
    <React.Fragment>
      MULTIPLE
      <br />
      GALAXIES
    </React.Fragment>
  ),
  group97: group97_group_9_1,
  group99: group99_group_98,
  spiralGalaxy: (
    <React.Fragment>
      SPIRAL <br />
      GALAXY
    </React.Fragment>
  ),
  spanText1: (
    <React.Fragment>
      You've made it to a new region of the cosmos. Billions upon billions of
      galaxies exist in the universe beyond our Milky Way galaxy, each a
      collection of stars, gas and dust bound together by gravity. Elegant
      spirals and luminous ellipticals are scattered throughout the universe
      alongside distorted galaxies caught in gravitational dances and small,
      shapeless, forming galaxies.
      <br />
    </React.Fragment>
  ),
  spanText2: "What should we visit?",
  welcomeToANewGa: (
    <React.Fragment>
      WELCOME TO A NEW <br />
      GALACTIC NEIGHBORHOOD!
    </React.Fragment>
  ),
  ellipticalGalaxy: (
    <React.Fragment>
      ELLIPTICAL
      <br />
      GALAXY
    </React.Fragment>
  ),
  group145: group145_group_144,
  group583: group_583,
  group136Props: group1364Data,
  click_me: click_me,
};

const group5804Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-3",
};

const web192027Data = {
  x45943962354_929Ead0C96_K: x45943962354_929Ead0C96_K,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  group583: group_583,
  globe: globe_img,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  watchAurora: "WATCH THE ROTATION",
  wingright: right_wing,
  leftwing: left_wing,
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
         INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  learnMore: "VISIT OTHER GALAXIES",
  overlapGroup4: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  travelAgainInSolarSystem: (
    <React.Fragment>
      TRAVEL AGAIN <br />
      IN SOLAR SYSTEM
    </React.Fragment>
  ),
  travelToMilkyWay: (
    <React.Fragment>
      EXPLORE OUR <br />
      GALAXY
    </React.Fragment>
  ),
  group580Props: group5804Data,
};

const group1122Data = {
  className: "group-112-1",
};

const web192024Data = {
  group112Props: group1122Data,
};

const group5805Data = {
  path691: path691_path_691_2,
  path692: path692_path_692_11,
  className: "group-5800-4",
};

const web192053Data = {
  x40387946030_Aa1Ab05241_3K: x40387946030_Aa1Ab05241_3K,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  path318: path318_path_318_1,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  learnMore: "EXPLORE OUR GALAXY",
  overlapGroup3: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  ellipticalGalaxyNgc1316: "Elliptical Galaxy NGC 1316",
  ellipticalGalaxies:
    "Surprisingly complex loops and blobs of cosmic dust lie across the face of the giant elliptical galaxy NGC 1316. These are thought to be the remains of the interstellar medium associated with one or more spiral galaxies that have been gravitaionally pulled into NGC 1316. The galaxy, located in the Fomax galaxy cluster, is believed to house a supermassive black hole that contains 130 million to 150 million solar masses.",
  flyBackToSolarSystem: (
    <React.Fragment>
         INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  group580Props: group5805Data,
};

const group5806Data = {
  path691: path691_path_691_11,
  path692: path692_path_692_11,
  className: "group-580-5",
};

const web1920101Data = {
  x47508827662_0Fb5Ab33C6_4K: x47508827662_0Fb5Ab33C6_4K,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  rocket: rocket_img,
  leftwing: left_wing,
  flyToIt: "FLY THROUGH IT!",
  learnMore: (
    <React.Fragment>
      EXPLORE OUR <br />
      GALAXY
    </React.Fragment>
  ),
  overlapGroup4: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  flyBackToSolarSystem: (
    <React.Fragment>
         INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER
      <br /> GALAXY
    </React.Fragment>
  ),
  group580Props: group5806Data,
};

const group5807Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-6",
};

const web1920130Data = {
  x46313556131_736414A7B5_K: overlapGroup1_k_1,
  subtraction1: subtraction1,
  finalOverlay: finalOverlay,
  rocket: rocket_img,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  flyToIt: "FLY ME TO IT",
  learnMore: "EXPLORE OUR GALAXY",
  wingright: right_wing,
  leftwing: left_wing,
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br />
      IN GALAXY
    </React.Fragment>
  ),
  overlapGroup5: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  goodsField: "GOODS Field",
  thisImageEncompass:
    "About 12,000 star-forming galaxies are visible in this image, which focuses on a part of the constellation Fomax known as the GOODS-South field. Observations in infrared, visible and ultraviolet light capture the largest panoramic view of the fire and fury of the star birth in the distant universe. The image straddles the gap between the very distant galaxies, which can only be viewed in infrared light, and closer galaxxies, which can be seen across different wavelengths.",
  flyBackToSolarSystem: (
    <React.Fragment>
         INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  group580Props: group5807Data,
  click_me: click_me,
};

const group5808Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-7",
};

const web192036Data = {
  x51218566742_5029299867_K: overlapGroup1_51218566742_5029299867_k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  group583: group_583,
  music: music_img,
  rocket: rocket_img,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  overlapGroup2: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  flyThroughIt: "FLY THROUGH IT!",
  translateintosound: "TRANSLATE INTO SOUND",
  learnMore: "EXPLORE OUR GALAXY",
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
    INVESTIGATE THE SOLAR SYSTEM
   
    </React.Fragment>
  ),
  group580Props: group5808Data,
};

const web192038Data = {
  x51218566742_5029299867_K: overlapGroup1_51218566742_5029299867_k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  overlapGroup2: overlapGroup5_path_407_10,
  viewFullscreenImage: "VIEW FULLSCREEN",
  polygon3: polygon3_polygon_3_10,
  hubbleUltraDeepField: "Hubble Ultra Deep Field 2014",
  thisUltraDeepFiel:
    "Data sonifications translate the same digital data used to create pictures into sound. Here a single note plays for each galaxy. The later the note plays, the farther away the galaxy is. The pitch of the note indicates the galaxy's color (lower notes are redder, higher notes are bluer) and the volume indicates the galaxy's apparent size. In just under a minute, we can hear back nearly 13 billion years to the farthest galaxies in that photo.",
  flyThroughIt: "FLY THROUGH IT!",
  translateintosound: "TRANSLATE INTO SOUND",
  learnMore: "EXPLORE OUR GALAXY",
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
    INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  group580Props: group5808Data,
  video: Ultra_Deep_Field,
  overlapGroup1: overlapGroup1_51218566742_5029299867_k_1,
  group138: group138_10,
  path128: path128_10,
  backToImage: "BACK TO IMAGE",
  click_me: click_me,
};

const web1920145Data = {
  x51218566742_5029299867_K: overlapGroup1_51218566742_5029299867_k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  overlapGroup2: overlapGroup5_path_407_10,
  viewFullscreenImage: "VIEW FULLSCREEN",
  polygon3: polygon3_polygon_3_10,
  hubbleUltraDeepField: "Pillars of Creation Sonification",
  thisUltraDeepFiel:
    "Data sonifications translate the same digital data used to create pictures into sound. In this sonification, sounds are generated by moving horizontally across the image from the left to right as seen in both visible and X-ray light. The vertical position of the recorded light controls the pitch. Particular attention is paid to the pillar's structure, which can be heard as sweeps from low to high pitches and back.",
  flyThroughIt: "FLY THROUGH IT!",
  translateintosound: "TRANSLATE INTO SOUND",
  learnMore: "EXPLORE OUR GALAXY",
  flyBackToSolarSystem: (
    <React.Fragment>
        INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  group580Props: group5808Data,
  video: Ultra_Deep_Field,
  overlapGroup1: overlapGroup1_51218566742_5029299867_k_1,
  group138: group138_10,
  path128: path128_10,
  backToImage: "BACK TO IMAGE",
  click_me: click_me,
};

const web192059Data = {
  x24850475098_Dc9Abdf3B9_4K: overlapGroup1_24850475098_dc9abdf3b9_4k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  overlapGroup2: overlapGroup5_path_407_10,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  polygon3: polygon3_polygon_3_10,
  flyToIt: "FLY THROUGH IT",
  turnToSound: "TRANSLATE INTO SOUND",
  learnMore: "VISIT OTHER GALAXIES",
  travelAgainInMilkyWay: (
    <React.Fragment>
      TRAVEL AGAIN
      <br />
      IN OUR GALAXY
    </React.Fragment>
  ),
  overlapGroup6: overlapGroup5_path_407_10,
  viewFullscreenImage: "VIEW FULLSCREEN",
  polygon3: polygon3_polygon_3_10,
  butterflyNebula: "Butterfly Nebula Sonification",
  whatResembleButter:
    "Data sonifications translate the same digital data used to create pictures into sound. Vertical position is mapped to pitched - meaning that light towards the top of the image is higher pitched. The nebula is played on strings and synthetic tones, while stars are represented by by digital harp. Brightness controls the volume, and the tilted hourglass orientation of the nebula produces an overall rising motion, with the prominent iron-rich jet producting a quick rise near the center.",
  travelToOtherGalaxies: (
    <React.Fragment>
        INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  click_me: click_me,
};

const web1920158Data = {
  x24850475098_Dc9Abdf3B9_4K: overlapGroup1_24850475098_dc9abdf3b9_4k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  overlapGroup2: overlapGroup5_path_407_10,
  group583: group_583,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  polygon3: polygon3_polygon_3_10,
  flyToIt: "FLY THROUGH IT",
  turnToSound: "TRANSLATE INTO SOUND",
  learnMore: "VISIT OTHER GALAXIES",
  travelAgainInMilkyWay: (
    <React.Fragment>
      TRAVEL AGAIN
      <br />
      IN OUR GALAXY
    </React.Fragment>
  ),
  overlapGroup6: overlapGroup5_path_407_10,
  viewFullscreenImage: "VIEW FULLSCREEN",
  polygon3: polygon3_polygon_3_10,
  catsEye: "Cat's Eye",
  catDescription:
    "Data sonifications translate the same digital data used to create pictures into sound. Vertical position is mapped to pitched - meaning that light towards the top of the image is higher pitched. The nebula is played on strings and synthetic tones, while stars are represented by by digital harp. Brightness controls the volume, and the tilted hourglass orientation of the nebula produces an overall rising motion, with the prominent iron-rich jet producting a quick rise near the center.",
  travelToOtherGalaxies: (
    <React.Fragment>
         INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  click_me: click_me,
};

const group5809Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-8",
};

const web1920104Data = {
  x50173806488_38F6267B2A_5K: x50173806488_38F6267B2A_5K,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  group583: group_583,
  star: music_img,
  overlapGroup2: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  wingright: right_wing,
  leftwing: left_wing,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  watchAnimation: (
    <React.Fragment>
      TRANSLATE <br />
      INTO SOUND
    </React.Fragment>
  ),
  learnMore: (
    <React.Fragment>
      EXPLORE OUR <br />
      GALAXY
    </React.Fragment>
  ),
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br />
      GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
    INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  group580Props: group5809Data,
};

const group1365Data = {
  className: "group-136-4",
};

const group2861Data = {
  children: (
    <React.Fragment>
      DYING STARS AND
      <br />
      THEIR REMNANTS
    </React.Fragment>
  ),
};

const group2862Data = {
  children: <React.Fragment>YOUNG STARS</React.Fragment>,
  className: "group-28",
};

const exploreOurMilkyWayData = {
  x698: x698_698_1,
  finalOverlay: finalOverlay,
  iWantToSeeAncientStars: " ANCIENT STARS",
  LETSFINDNEWBORNSTARS: "YOUNG STARS",
  HOWABOUTSEEINGDYINGSTARS: "HOW ABOUT SEEINGDYING STARS",
  path14: path_14_10,
  path15: path15_10,
  subtraction1: subtraction1,
  group167: group167_group_49,
  group166: group166_group_75,
  group583: group_583,
  line39: line39_1,
  line40: line39_1,
  line41: line41_1,
  line42: line41_1,
  line43: line43_1,
  group78: group78_group_77,
  line46: line46_line_45,
  line47: line47_1,
  line48: line47_1,
  line49: line49_1,
  line50: line49_1,
  group80: group80_circle,
  group165: group165_group_102,
  path128: path128_path_128_9,
  spanText1: (
    <React.Fragment>
      Our galaxy is a vast island of stars in different stages of life. There
      are about 100 billion stars in the Milky Way, a pinwheel-shaped spiral
      galaxy approximately 100,000 light-years across. Our own Sun lies in one
      of the Milky Way's spiral arms, about two-thirds of the way outward from
      the galaxy's center. <br />
    </React.Fragment>
  ),
  spanText2: "What kind of stars do you want to see?",
  welcomeToTheMilkyWay: "WELCOME TO THE MILKY WAY.",
  group5831: group_583,
  group5832: group_583,
  group136Props: group1365Data,
  group2861Props: group2861Data,
  group2862Props: group2862Data,
  click_me: click_me,
};

const group58010Data = {
  path691: path691_path_691_2,
  path692: path692_path_692_9,
  className: "group-580-9",
};

const web192020Data = {
  x36345580381_68E41A943C_K:
    x36345580381_68E41A943C_K_36345580381_68e41a943c_k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1,
  group583: group_583,
  learnMore: "VISIT OTHER GALAXIES",
  overlapGroup3: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  turnToSound: (
    <React.Fragment>
      TRANSLATE <br />
      INTO SOUND
    </React.Fragment>
  ),
  music: music_img,
  m30: "M30",
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
    INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  thisImageOfM30Is:
    "Messier 30 (M30) is a globular cluster containing several hundred thousand stars. Although globular clusters such as M30 are mainly populated by old stars, the steller swarm is so dense that it can lead to some old stars being restored to youth as 'blue stragglers.' There are two type of blue stragglers in M30; those that form in near head-on collisions between two stars, and those that are in binary systems where one star pulls hydrogen from its companion.",
  travelAgainInMilkyWay: (
    <React.Fragment>
      TRAVEL AGAIN <br />
      IN OUR GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
      INVESTIGATE OUR
      <br /> SOLAR SYSTEM
    </React.Fragment>
  ),
  group580Props: group58010Data,
};

const group58011Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-10",
};

const web1920136Data = {
  x38451843462_E970E5F167_K: overlapGroup_38451843462_e970e5f167_k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1,
  group583: group_583,
  flyThrough: "FLY THROUGH!",
  learnMore: "LEARN MORE",
  travelAgainInMilkyWay: (
    <React.Fragment>
      TRAVEL AGAIN <br />
      IN MILKY WAY
    </React.Fragment>
  ),
  overlapGroup5: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  name: "Orion Nebula",
  thisDramaticImage:
    "This dramatic image offers a peek inside a cavern of roiling dust and gas where thousands of stars are forming. The image represents the sharpest view ever taken of this region, called the Orion Nebula. More than 3,000 stars of various sizes appeared in the 1 billion pixel version of this image. The Orion Nebula is 1,500 light-years away, the nearest star-forming region to Earth.",
  travelToOtherGalaxies: (
    <React.Fragment>
      TRAVEL TO
      <br /> OTHER GALAXIES
    </React.Fragment>
  ),
  group580Props: group58011Data,
  click_me: click_me,
};

const group58012Data = {
  path691: path691_path_691_11,
  path692: path692_path_692_11,
  className: "group-580-11",
};

const web1920147Data = {
  x24850475098_Dc9Abdf3B9_4K: overlapGroup1_24850475098_dc9abdf3b9_4k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  overlapGroup3: overlapGroup5_path_407_10,
  group583: group_583,
  rocket: rocket_img,
  music: music_img,
  group42: group42_group_41,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  flyToIt: "FLY THROUGH IT",
  turnToSound: "TRANSLATE INTO SOUND",
  learnMore: (
    <React.Fragment>
      EXPLORE OUR <br />
      GALAXY
    </React.Fragment>
  ),
  visitOtherGalaxies: (
    <React.Fragment>
      VISIT OTHER  <br />
      GALAXIES
    </React.Fragment>
  ),
  travelAgainInMilkyWay: (
    <React.Fragment>
      TRAVEL AGAIN
      <br />
      IN OUR GALAXY
    </React.Fragment>
  ),
  overlapGroup6: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
       INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  polygon3: polygon3_polygon_3_10,
  click_me: click_me,
  travelToOtherGalaxies: (
    <React.Fragment>
      INVESTIGATE THE
      <br />
      SOLAR SYSTEM
    </React.Fragment>
  ),
  group580Props: group58012Data,
};

const group58013Data = {
  path691: path691_path_691_10,
  path692: path692_path_692_10,
  className: "group-580-12",
};

const web1920155Data = {
  x27950248711_D1329Dfb69_6K: overlapGroup_27950248711_d1329dfb69_6k_1,
  finalOverlay: finalOverlay,
  subtraction1: subtraction1_10,
  overlapGroup3: overlapGroup5_path_407_10,
  flyThrough: "FLY THROUGH IT",
  turnToSound: (
    <React.Fragment>
      TRANSLATE <br />
      INTO SOUND
    </React.Fragment>
  ),
  learnMore: "VISIT OTHER GALAXIES",
  group42: group42_group_41,
  rocket: rocket_img,
  music: music_img,
  video: cosmic_vido,
  group287: group287_group_100,
  group45: group45_group_45,
  wingright: right_wing,
  leftwing: left_wing,
  overlapGroup5: overlapGroup5_path_407_10,
  viewFullscreenImage: "Close control panel",
  polygon3: polygon3_polygon_3_10,
  group583: group_583,
  travelAgainInGalaxies: (
    <React.Fragment>
      VISIT ANOTHER <br /> GALAXY
    </React.Fragment>
  ),
  flyBackToSolarSystem: (
    <React.Fragment>
        INVESTIGATE THE SOLAR SYSTEM

    </React.Fragment>
  ),
  click_me: click_me,
  travelAgainInMilkyWay: (
    <React.Fragment>
      TRAVEL AGAIN <br />
      IN OUR GALAXY
    </React.Fragment>
  ),
  travelToOtherGalaxies: (
    <React.Fragment>
     INVESTIGATE THE SOLAR SYSTEM
    </React.Fragment>
  ),
  group580Props: group58013Data,
};

const group1812Data = {
  className: "group-278",
};

const web1920142Data = {
  group181Props: group1812Data,
};

const ancientStars1Data = {
  x698: x698_698_1,
  finalOverlay: finalOverlay,
  group136: group136_1,

  spanText1: (
    <React.Fragment>
      Since the first stars and galaxies came into being, their light has been traveling through space. The light from the most distant reaches of the universe takes the longest to reach us, and even the light we see from the galaxies nearest our own has been traveling for millions of light-years. When we look into space, we see not just the presence but the history of galaxies, stretching back in both space and time. Choose to view the universe through a deep field or a cosmic lens created by gravity.
      <br />
    </React.Fragment>
  ),
  whichViewWouldYouLikeToSee: "A TREASURE TROVE OF GALAXIES LIES BEFORE YOU.",
  subtraction1: subtraction1_10,
  iWantToSeeAGravitationalLense: "COSMIC LENS",
  group270: group270_group_270_1,
  group267: group267_group_266_1,
  interactingGalaxy: "INTERACTING GALAXY",
  iWantToSeeADeepField: <React.Fragment>DEEP FIELD</React.Fragment>,
  group583: group_583,
  click_me: click_me,
};